export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const toLimitedCharacters = (string, number) => {
  return `${string.slice(0, number)}...`;
};
